export const SET_GUIDE = "@SETTINGS/GUIDE_DEF/SET_GUIDE";
export const SET_GUIDE_LIST = "@SETTINGS/GUIDE_DEF/SET_GUIDE_LIST";
